import { useQuery } from 'react-query';
import http from '../config/http-service';
import type { MasterProductUsage } from './types';
import { masterProductsEndpoint } from './use-get-master-products-api';

// GET api/v1/cms/master-products/:id/usage
export const useGetMasterProductUsageApi = (id?: number, options: { enabled?: boolean } = {}) => {
  return useQuery({
    // 'usage' segment keeps this out of both the by-family list key
    // [endpoint, familyId] and the detail key [endpoint, 'detail', id].
    queryKey: [masterProductsEndpoint, 'usage', id],
    queryFn: async (): Promise<MasterProductUsage> => {
      const { data } = await http.get(`${masterProductsEndpoint}/${id}/usage`);
      // The API wraps the resource in an envelope: { data: {...} }.
      return data?.data ?? data;
    },
    enabled: options.enabled ?? !!id,
  });
};
